import '../sass/modal.scss';

import ModalMenu from '../components/modals/ModalMenu';

export { ModalMenu };


// WEBPACK FOOTER //
// ./src/containers/Modals.js